const theme = {
    id: 'light',
    primaryColor: '#f8049c',
    secondaryColor: '#fdd54f',
    bodyBackgroundColor: '#ffffff',
    bodyFontColor: 'black'
};

export default theme;